<template>
  <v-toolbar class="fixed-toolbar" density="compact" :elevation="4">
    <v-btn prepend-icon="mdi-check-circle" @click="openDialog">
      {{ $t('item_list.add_item') }}
    </v-btn>

    <v-btn prepend-icon="mdi-magnify" @click="toggleOperationType">
      <span v-if="operationType === 0">{{ $t('item_list.watch_the_buy') }}</span>
      <span v-if="operationType === 1">{{ $t('item_list.watch_the_stock') }}</span>
    </v-btn>

    <v-spacer></v-spacer>
    <v-menu v-model="isMenuOpen"> <!-- v-modelでメニューの開閉状態を監視 -->
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" @click="item.action">
          <v-icon left>{{ item.icon }}</v-icon>
          <v-list-item-title style="display: inline; margin-left: 10px;">{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-icon left>mdi-update</v-icon>
          <v-list-item-title style="display: inline; margin-left: 10px;">{{ $t('menu_last_update') }}:{{ list_updated_at }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>

  <ItemDialog v-if="dialog" :initial-visible="dialog" :input_type="input_type" :target_item="target_item"
    @closed="dialogclose" @updateflag="updateflag"></ItemDialog>

  <!-- URLシェアダイアログの追加 -->
  <v-dialog v-model="URLShareDialogVisible" max-width="90%">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('menu_share_url') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeURLShareDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <ShareURL />
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- FAQダイアログの追加 -->
  <v-dialog v-model="faqDialogVisible" max-width="90%">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('menu_faq') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeFaqDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <FAQContent />
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- 利用規約ダイアログの追加 -->
  <v-dialog v-model="termsDialogVisible" max-width="90%">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('menu_terms_policy') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeTermsDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <TermsContent />
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- 警告モーダルの追加 -->
  <v-dialog v-model="warningDialogVisible" max-width="500">
    <v-card>
      <v-card-title class="headline">{{ $t('dialogs.warning_title') }}</v-card-title>
      <v-card-text>
        {{ $t('dialogs.delete_warning') }}
      </v-card-text>
      <v-card-actions>
        <v-btn color="red darken-1" text @click="closeWarningDialog">{{ $t('buttons.cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="confirmDeletion">{{ $t('buttons.confirm_deletion') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import axios from 'axios'
import ItemDialog from '@/components/ItemDialog.vue'
import ShareURL from '@/components/ShareURL.vue'
import FAQContent from '@/components/FAQContent.vue'
import TermsContent from '@/components/TermsContent.vue'


export default {
  name: 'MainHeader',
  components: {
    ItemDialog,
    ShareURL,
    FAQContent,
    TermsContent
  },
  props: {
    list_updated_at: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      isMenuOpen: false, // メニューが開いているかどうかの状態を管理
      menuItems: []
    }
  },
  async mounted() {
    await this.make_transelate_menu();
  },
  watch: {
    '$i18n.locale': function () {
      this.make_transelate_menu();
      console.log('Locale changed');
    },
  },
  methods: {
    async make_transelate_menu() {
      let no_translate_category_list = [
        { title: 'menu_edit_category', icon: 'mdi-pencil', action: () => this.navigateTo('editcategory') },
        { title: 'menu_share_url', icon: 'mdi-share-variant', action: () => this.openURLShareDialog() },
        { title: 'menu_faq', icon: 'mdi-help-circle-outline', action: () => this.openFaqDialog() },
        { title: 'menu_terms_policy', icon: 'mdi-file-document-outline', action: () => this.openTermsDialog() },
        { title: 'menu_language', icon: 'mdi-web', action: () => this.changeLocale() },
        { title: 'menu_delete_data', icon: 'mdi-delete', action: () => this.openWarningDialog() },
        { title: 'menu_home_screen', icon: 'mdi-home', action: () => this.navigateTo('home') }
      ];

      // map を使って title を翻訳して新しい配列を作成
      this.menuItems = no_translate_category_list.map(item => {
        return {
          ...item,  // オブジェクトの他のプロパティはそのままコピー
          title: this.$t(item.title)  // title プロパティを翻訳
        };
      });

    },
    navigateTo(routeName) {
      this.$router.push({ name: routeName }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', error);
        }
      });
    }
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const dialog = ref(false)
    const target_item = reactive({})
    const input_type = ref("regist")
    const operationType = ref(0)
    const URLShareDialogVisible = ref(false)
    const faqDialogVisible = ref(false)
    const termsDialogVisible = ref(false)
    const warningDialogVisible = ref(false) // 警告モーダルの表示状態を管理
    const delete_btn_loading = ref(false)

    const openDialog = () => {
      Object.assign(target_item, {})
      dialog.value = true
    }

    const dialogclose = () => {
      dialog.value = false
    }

    const updateflag = () => {
      router.go({ path: router.currentRoute.path, force: true })
      // Implement update logic here
    }

    const toggleOperationType = () => {
      operationType.value = operationType.value === 0 ? 1 : 0;
      store.commit('setOperationType', operationType.value);  // Vuexに変更を反映
    }

    const openFaqDialog = () => {
      faqDialogVisible.value = true
    }

    const closeFaqDialog = () => {
      faqDialogVisible.value = false
    }

    const openTermsDialog = () => {
      termsDialogVisible.value = true
    }

    const closeTermsDialog = () => {
      termsDialogVisible.value = false
    }

    const openURLShareDialog = () => {
      URLShareDialogVisible.value = true
    }

    const closeURLShareDialog = () => {
      URLShareDialogVisible.value = false
    }

    const openWarningDialog = () => {
      warningDialogVisible.value = true
    }

    const closeWarningDialog = () => {
      warningDialogVisible.value = false
    }

    const sendApiRequest = async (apiEndpoint, jsonBody, successCallback, errorCallback) => {
      try {
        const response = await axios.post(`${store.state.api_baseurl}${apiEndpoint}`, jsonBody, store.state.post_headers);
        if (successCallback) successCallback(response.data);
      } catch (error) {
        console.error(error);
        if (errorCallback) errorCallback(error);
        else alert(error); // エラーハンドリングが未定義の場合のデフォルト処理
      }
    }

    const deleteUserAndClearLocalStorage = async () => {
      const jsonBody = {
        api_type: "deleteuser",
        user_id: store.state.user_info.user_id
      };

      delete_btn_loading.value = true;

      const successCallback = () => {
        localStorage.clear();
        store.commit('resetState');  // ストアの状態をリセット
        router.push('/')
      };

      await sendApiRequest('deleteuser', jsonBody, successCallback);

      delete_btn_loading.value = false;
    }

    const confirmDeletion = async () => {
      closeWarningDialog(); // モーダルを閉じる
      await deleteUserAndClearLocalStorage(); // データ削除処理を実行
    }

    return {
      dialog,
      target_item,
      input_type,
      operationType,
      URLShareDialogVisible,
      faqDialogVisible,
      termsDialogVisible,
      warningDialogVisible,
      delete_btn_loading,
      openDialog,
      dialogclose,
      updateflag,
      toggleOperationType,
      openURLShareDialog,
      closeURLShareDialog,
      openFaqDialog,
      closeFaqDialog,
      openTermsDialog,
      closeTermsDialog,
      openWarningDialog,
      closeWarningDialog,
      confirmDeletion, // データ削除確認用の関数
    }
  }
}
</script>
<style scoped>
.fixed-toolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  /* ツールバーを他のコンテンツより前に表示 */
}

/* ツールバーが固定されているため、下のコンテンツが被らないようにする */
.content {
  padding-top: 64px;
  /* ツールバーの高さを考慮 */
}
</style>